// extracted by mini-css-extract-plugin
module.exports = {"intervalSpace":"index_intervalSpace__1Yj0s"};